// import { Component, OnInit } from '@angular/core';
// import { Title } from '@angular/platform-browser';
// import {
//   LocalizationService,
//   AuthService,
//   ReplaceableComponentsService,
//   ConfigStateService,
//   ApplicationConfigurationDto,
// } from '@abp/ng.core';
// import { eThemeBasicComponents } from '@abp/ng.theme.basic';
// import { Store, Select } from '@ngxs/store';
// import { GetUserProfile, GetCustomer, GetVendor, GetPageLayout } from './app.actions';
// import { pluck } from 'rxjs/operators';
// import { Observable, Subject } from 'rxjs';
// import { ApplicationInsightsService } from './core/error/applicationinsights.service';
// import { AppState } from './app.state';
// import { PageLayoutContent } from './app.model';
// import { FirebaseMessagingService } from './service/firebase-messaging.service';

// @Component({
//   selector: 'app-root',
//   templateUrl: './app.component.html',
//   styleUrls: ['./app.component.scss'],
// })
// export class AppComponent implements OnInit {
//   private destroy$ = new Subject<void>();
//     currentUser$: Observable<ApplicationConfigurationDto['currentUser']>;
//     currentUser: ApplicationConfigurationDto['currentUser'];

//   //isLoggedIn: boolean;

//   @Select(AppState.getPageLayoutContent)
//   pageLayout$: Observable<PageLayoutContent>;
//   loading: boolean;

//   public constructor(
//     applicationInsightsService: ApplicationInsightsService,
//     private titleService: Title,
//     private localizationService: LocalizationService,
//     public authService: AuthService,
//     private replaceableComponents: ReplaceableComponentsService,
//     private store: Store,
//     private messagingService: FirebaseMessagingService
//   ) {
//     this.currentUser$ = this.store.select(state => state.ConfigState?.currentUser);
//     this.isLoggedIn = this.isCurrentlyLoggedIn();
//     this.replaceableComponents.add({
//       component: null,
//       key: eThemeBasicComponents.ApplicationLayout,
//     });
//     this.replaceableComponents.add({
//       component: null,
//       key: eThemeBasicComponents.AccountLayout,
//     });

//     this.currentUser$.subscribe(c => {
//       if (c?.isAuthenticated) {
//         applicationInsightsService.setUserId(c.userName);
//         this.currentUser = c;
//         if (this.currentUser?.id) {
//           this.store
//             .dispatch(new GetUserProfile())
//             .pipe(pluck('AppState', 'userProfile'))
//             .subscribe((u: any) => {
//               this.store.dispatch(new GetPageLayout())
//                 .pipe(pluck('AppState', 'pageLayoutContent'))
//                 .subscribe(s => { this.loading = true; });

//               if (u?.customer) {
//                 this.store
//                   .dispatch(new GetCustomer())
//                   .pipe(pluck('AppState', 'customer'))
//                   .subscribe(s => { });
//               }
//               if (u?.vendor) {
//                 this.store
//                   .dispatch(new GetVendor())
//                   .pipe(pluck('AppState', 'vendor'))
//                   .subscribe(s => { });
//               }
//             });
//         }
//       } else {
//         applicationInsightsService.clearUserId();
//       }
//     });

//     this.pageLayout$.subscribe(s => {
//       if (s) {
//         const pageLayout = s.pageLayout;
//         if (pageLayout.noAnimations) {
//           document.body.classList.add("no-animations");
//         } else {
//           document.body.classList.remove("no-animations");
//         }
//       }
//     });
//   }

//   // isCurrentlyLoggedIn() {
//   //   return this.oAuthService.hasValidAccessToken();
//   // }

//   ngOnInit(): void {
//     alert('AppComponent Init called');
//     alert('Is logged in: ' + this.oAuthService.hasValidAccessToken());
//     // const appName = localStorage.getItem('tenant_AppName') || this.localizationService.instant('::AppName');
//     // this.titleService.setTitle(appName);
//     // if (this.oAuthService.hasValidAccessToken()) {
//     //   // cleanup URL to stop loop
//     //   window.history.replaceState({}, document.title, window.location.origin);
//     // };
//     if (this.oAuthService.hasValidAccessToken()) {   
//       window.history.replaceState({}, document.title, window.location.origin);
//     }
//     //this.registerServiceWorker();
//     //this.messagingService.init();
//   }
//   private registerServiceWorker() {
//   if ('serviceWorker' in navigator) {
//     navigator.serviceWorker.register('/firebase-messaging-sw.js')
//       .then((registration) => {
//       })
//       .catch((error) => {
//         console.error('SW registration failed:', error);
//       });
//   }
// }
// }
import { Store } from '@ngxs/store';
import { GetPageLayout } from './app.actions';
import { Component, OnInit } from '@angular/core';
import { FirebaseMessagingService } from './service/firebase-messaging.service';

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent implements OnInit {

  constructor(private store: Store,
    private fcmService: FirebaseMessagingService
  ) {}

  ngOnInit(): void {
    // ✅ Dispatch layout
    this.store.dispatch(new GetPageLayout());

    // ✅ Register service worker
    this.registerFirebaseServiceWorker();

    // ✅ CRITICAL: This triggers token generation
    this.fcmService.requestAndSaveToken();
  }

  private registerFirebaseServiceWorker(): void {
    if (!('serviceWorker' in navigator)) {
      console.warn('Service worker is not supported in this browser.');
      return;
    }

    navigator.serviceWorker
      .register('/firebase-messaging-sw.js')
      .then((registration) => {
        console.log('✅ Firebase service worker registered:', registration);
      })
      .catch((error) => {
        console.error('❌ Firebase service worker registration failed:', error);
      });
  }
}